<header
  class="sticky top-0 z-40 border-b border-line transition-[background-color,box-shadow,backdrop-filter] duration-200"
  [class.bg-cream]="!scrolled()"
  [class.bg-cream/75]="scrolled()"
  [class.backdrop-blur-md]="scrolled()"
  [class.shadow-sm]="scrolled()"
>
  <div class="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 sm:px-6 lg:px-8">
    <a routerLink="/" class="flex items-center gap-2" (click)="closeMobileMenu()">
      <img src="assets/branding/icon-32@2x.png" alt="" class="h-10 w-auto" width="64" height="64" />
      <span class="font-display text-xl font-semibold tracking-[0.18em] text-forest">GALOPA</span>
    </a>

    <nav class="hidden items-center gap-8 md:flex">
      <a
        routerLink="/shop"
        routerLinkActive="text-forest"
        class="text-sm font-medium text-ink hover:text-forest"
        >Shop</a
      >
      <a routerLink="/account/listings/new" class="text-sm font-medium text-ink hover:text-forest"
        >Sell a Saddle</a
      >
      <a
        routerLink="/secure-trade"
        routerLinkActive="text-forest"
        class="text-sm font-medium text-ink hover:text-forest"
        >Secure Trade</a
      >
      <a
        routerLink="/saddle-finder"
        routerLinkActive="text-forest"
        class="text-sm font-medium text-ink hover:text-forest"
        >Saddle Finder</a
      >
      <a
        [routerLink]="['/']"
        fragment="how-it-works"
        class="text-sm font-medium text-ink hover:text-forest"
        >How It Works</a
      >
      <a
        [routerLink]="['/']"
        fragment="safety"
        class="text-sm font-medium text-ink hover:text-forest"
        >Buyer Protection</a
      >
    </nav>

    <div class="flex items-center gap-3">
      @if (!authService.authReady() || !authService.isAuthenticated()) {
        <a
          routerLink="/login"
          class="hidden text-sm font-medium text-ink hover:text-forest sm:inline"
        >
          Log in
        </a>
        <a
          routerLink="/signup"
          class="rounded-full bg-forest px-4 py-2 text-sm font-medium text-cream transition hover:bg-forestdark"
        >
          Sign up
        </a>
      } @else {
        <div class="relative">
          <button
            type="button"
            class="cursor-pointer relative flex items-center gap-2 rounded-full border border-line px-3 py-1.5 text-sm font-medium text-ink hover:border-tan"
            (click)="toggleAccountMenu()"
          >
            <span
              class="flex h-6 w-6 items-center justify-center rounded-full bg-forest text-xs font-semibold text-cream"
            >
              {{ authService.currentUser()?.firstName?.charAt(0) }}
            </span>
            {{ authService.currentUser()?.firstName }}
            @if (sellerAlertsService.urgentCount() > 0) {
              <span
                class="absolute -top-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full bg-rose text-[10px] font-bold text-cream ring-2 ring-cream"
                [attr.aria-label]="sellerAlertsService.urgentCount() + ' items need your attention'"
              >
                {{ sellerAlertsService.urgentCount() }}
              </span>
            }
          </button>

          @if (accountMenuOpen()) {
            <div
              class="absolute right-0 mt-2 w-52 rounded-lg border border-line bg-cream py-2 shadow-lg"
              (mouseleave)="closeAccountMenu()"
            >
              <a
                routerLink="/account/overview"
                class="block px-4 py-2 text-sm text-ink hover:bg-creamdark"
                (click)="closeAccountMenu()"
                >Account</a
              >
              <a
                routerLink="/account/selling"
                class="flex items-center justify-between px-4 py-2 text-sm text-ink hover:bg-creamdark"
                (click)="closeAccountMenu()"
              >
                Offers &amp; Requests
                @if (sellerAlertsService.urgentCount() > 0) {
                  <span
                    class="flex h-5 min-w-5 items-center justify-center rounded-full bg-rose px-1 text-[11px] font-semibold text-cream"
                  >
                    {{ sellerAlertsService.urgentCount() }}
                  </span>
                }
              </a>
              <a
                routerLink="/account/orders"
                class="block px-4 py-2 text-sm text-ink hover:bg-creamdark"
                (click)="closeAccountMenu()"
                >My Orders</a
              >
              <a
                routerLink="/account/listings"
                class="block px-4 py-2 text-sm text-ink hover:bg-creamdark"
                (click)="closeAccountMenu()"
                >My Listings</a
              >
              <a
                routerLink="/account/saved"
                class="block px-4 py-2 text-sm text-ink hover:bg-creamdark"
                (click)="closeAccountMenu()"
                >Saved Saddles</a
              >
              <a
                routerLink="/account/messages"
                class="block px-4 py-2 text-sm text-ink hover:bg-creamdark"
                (click)="closeAccountMenu()"
                >Messages</a
              >
              <a
                routerLink="/account/profile"
                class="block px-4 py-2 text-sm text-ink hover:bg-creamdark"
                (click)="closeAccountMenu()"
                >Profile &amp; Addresses</a
              >
              <button
                type="button"
                class="block w-full cursor-pointer px-4 py-2 text-left text-sm text-rose hover:bg-creamdark"
                (click)="logout()"
              >
                Log out
              </button>
            </div>
          }
        </div>
      }

      <button
        type="button"
        class="cursor-pointer relative inline-flex items-center justify-center rounded-full p-2 text-ink hover:bg-creamdark md:hidden"
        (click)="toggleMobileMenu()"
        [attr.aria-expanded]="mobileMenuOpen()"
        aria-label="Open menu"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.5"
          class="h-6 w-6"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M3.75 6.75h16.5M3.75 12h16.5M3.75 17.25h16.5"
          />
        </svg>
        @if (authService.isAuthenticated() && sellerAlertsService.urgentCount() > 0) {
          <span
            class="absolute top-1 right-1 h-2.5 w-2.5 rounded-full bg-rose ring-2 ring-cream"
            aria-hidden="true"
          ></span>
        }
      </button>
    </div>
  </div>
</header>

@if (mobileMenuOpen()) {
  <div class="fixed inset-0 z-50 md:hidden" role="dialog" aria-modal="true" aria-label="Menu">
    <button
      type="button"
      class="cursor-pointer absolute inset-0 bg-ink/40"
      aria-label="Close menu"
      (click)="closeMobileMenu()"
    ></button>

    <div class="absolute inset-y-0 left-0 flex w-[min(20rem,80vw)] flex-col bg-cream shadow-xl">
      <div class="flex items-center px-5 pt-5 pb-2">
        <button
          type="button"
          class="cursor-pointer inline-flex items-center justify-center p-1 text-ink"
          (click)="closeMobileMenu()"
          aria-label="Close menu"
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            class="h-6 w-6"
          >
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <nav class="flex flex-1 flex-col overflow-y-auto">
        <a
          routerLink="/shop"
          class="border-b border-line px-6 py-4 text-lg font-medium text-ink"
          (click)="closeMobileMenu()"
          >Shop</a
        >
        <a
          routerLink="/saddle-finder"
          class="border-b border-line px-6 py-4 text-lg font-medium text-ink"
          (click)="closeMobileMenu()"
          >Saddle Finder</a
        >
        @if (authService.isAuthenticated()) {
          <a
            routerLink="/account/selling"
            class="flex items-center justify-between border-b border-line px-6 py-4 text-lg font-medium text-ink"
            (click)="closeMobileMenu()"
          >
            Offers &amp; Requests
            @if (sellerAlertsService.urgentCount() > 0) {
              <span
                class="flex h-6 min-w-6 items-center justify-center rounded-full bg-rose px-1.5 text-sm font-semibold text-cream"
              >
                {{ sellerAlertsService.urgentCount() }}
              </span>
            }
          </a>
          <a
            routerLink="/account/saved"
            class="border-b border-line px-6 py-4 text-lg font-medium text-ink"
            (click)="closeMobileMenu()"
            >Saved Saddles</a
          >
          <a
            routerLink="/account/messages"
            class="border-b border-line px-6 py-4 text-lg font-medium text-ink"
            (click)="closeMobileMenu()"
            >Messages</a
          >
          <a
            routerLink="/account/listings"
            class="border-b border-line px-6 py-4 text-lg font-medium text-ink"
            (click)="closeMobileMenu()"
            >Selling</a
          >
          <a
            routerLink="/account/profile"
            class="flex items-center justify-between border-b border-line px-6 py-4 text-lg font-medium text-ink"
            (click)="closeMobileMenu()"
          >
            Profile
            <!-- <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" class="h-5 w-5 text-ink/50" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
            </svg> -->
          </a>
        }
        <a
          [routerLink]="['/']"
          fragment="how-it-works"
          class="border-b border-line px-6 py-4 text-lg font-medium text-ink"
          (click)="closeMobileMenu()"
          >How It Works</a
        >
        <a
          [routerLink]="['/']"
          fragment="safety"
          class="border-b border-line px-6 py-4 text-lg font-medium text-ink"
          (click)="closeMobileMenu()"
          >Buyer Protection</a
        >
        <a
          routerLink="/help"
          class="flex items-center justify-between border-b border-line px-6 py-4 text-lg font-medium text-ink"
          (click)="closeMobileMenu()"
        >
          Help
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            class="h-5 w-5 text-ink/50"
            aria-hidden="true"
          >
            <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
          </svg>
        </a>
        @if (!authService.isAuthenticated()) {
          <a
            routerLink="/login"
            class="border-b border-line px-6 py-4 text-lg font-medium text-ink"
            (click)="closeMobileMenu()"
            >Log in</a
          >
        } @else {
          <button
            type="button"
            class="cursor-pointer border-b border-line px-6 py-4 text-left text-lg font-medium text-rose"
            (click)="logout(); closeMobileMenu()"
          >
            Log out
          </button>
        }

        <div class="mt-6 px-6 pb-8">
          <a
            routerLink="/account/listings/new"
            class="flex w-full items-center justify-center rounded-xl border border-ink px-4 py-3.5 text-base font-medium text-ink transition hover:bg-creamdark"
            (click)="closeMobileMenu()"
          >
            Sell your saddle
          </a>
        </div>
      </nav>
    </div>
  </div>
}
